import React from 'react';
import {
  useDropzone,
  useFileInput,
} from '@uppy/react';

interface DropzoneProps {
  variant?: 'memory' | 'sprk';
}

const Dropzone: React.FC<DropzoneProps> = ({ variant }) => {
  const { getRootProps, getInputProps } = useDropzone();
  const { getButtonProps } = useFileInput();

  return (
    <div className="memory-files-dropzone">
      <input {...getInputProps()} className="wa-visually-hidden" />
      <div {...getRootProps()} className="dropzone-area">
        {variant === 'sprk' ? (
          <>
            <p><i className="fa-regular fa-arrow-up-from-bracket" /> Upload your own photo or video</p>
            <span></span>
          </>
        ) : (
          <>
            <i className="fa-light fa-arrow-up-from-bracket fa-3x" />
            <p><strong>Drop files here or browse</strong></p>
            <span>Photos, video, audio supported · Dates read from file metadata automatically</span>
          </>
        )}
        <wa-button {...getButtonProps()}>
          {variant === 'sprk' ? 'Choose file' : 'Choose files'}
        </wa-button>
      </div>
    </div>
  );
}

export default Dropzone;
